import { Form, Spinner, Table } from 'react-bootstrap'
import './SoftwareVersions.scss'
import { useTranslation } from 'react-i18next'
import { useRef, useState } from 'react'
import { IToastProps, NotificationToast } from 'aw-notificationtoast';

export interface SoftwareVersion {
    idversion: number;
    version: string;
    crc: string;
    date: string;
}


const SoftwareVersions = (props: { versions: SoftwareVersion[], updateVersionList: (vObj: string) => void }) => {

    const { t } = useTranslation()
    const [toast, setToast] = useState<IToastProps>({ showToast: false, msg: '', fail: false })

    const [loading, setLoading] = useState(false)
    const [versionName, setVersionName] = useState('')
    const [file, setFile] = useState<File | null>(null);
    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (!isDragging) {
            setIsDragging(true);
        }
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const droppedFile = e.dataTransfer.files[0];
            handleFileChange(droppedFile);
        }
    };

    const handleFileChange = (selectedFile: File) => {
        const fileExtension = selectedFile.name.split('.').pop()?.toLowerCase();
        if (fileExtension && ['pdf'].includes(fileExtension)) {
            setFile(selectedFile);
        } else {
            showToastTimeOut(t('NoCorrectFormat'), true)
        }
    };

    const handleSelectFile = () => {
        fileInputRef.current?.click();
    };

    const handleInputFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            handleFileChange(e.target.files[0]);
        }
    };

    const showToastTimeOut = (msg: string, failToast: boolean) => {
        setToast({ showToast: true, msg: msg, fail: failToast })
        setTimeout(() => setToast({ showToast: false, msg: msg, fail: failToast }), 2000)
    }

    const onLoadVersion = () => {
        if (!file) {
            showToastTimeOut(t('FileMissing'), true)
            return;
        }
        const v = versionName.trim()
        if (!v) {
            showToastTimeOut(t('VersionMissing'), true)
            return;
        }
        setLoading(true)
        try {
            props.updateVersionList(v);
            setVersionName('')
            setFile(null)
        } finally {
            setLoading(false)
        }

    }

    return (
        <>
            <NotificationToast showToast={toast.showToast} msg={toast.msg} fail={toast.fail} />
            <div className={`p-2 rounded-1`} id='softVerContainer'>
                <p className="mt-1 h4 text-center">{t('SoftwareVersions')}</p>
                <div className='row p-2'>
                    <div className="d-flex flex-column gap-3 pt-1">
                        <section className='d-flex justify-content-between align-items-end'>
                            <section>
                                <Form.Label className='mb-0'>{t('Version')}</Form.Label>
                                <Form.Control name="verNumber" disabled={loading} type="text" value={versionName} onChange={(e: any) => setVersionName(e.target.value)} />
                            </section>
                            <button className='btn-Custom btn-IDGreen'  disabled={loading || !file || !versionName.trim()} onClick={() => onLoadVersion()}>{t('Load')}</button>
                        </section>
                    </div>
                </div>
                <div className='row my-2 py-2 px-2'>
                    <div className="col-12 px-2">
                        <div
                            className={`drag-drop-area ${isDragging ? 'dragging' : ''}`}
                            onDragEnter={handleDragEnter}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={handleSelectFile}
                        >
                            <input type="file" ref={fileInputRef} onChange={handleInputFileChange} className="file-input" accept=".pdf" />
                            <div className="upload-icon">
                                <i className="bi bi-cloud-arrow-up"></i>
                            </div>
                            <button type="button" className="btn select-file-btn"> {t('SelectFile')} </button>
                            {file && (
                                <div className="selected-file my-2">
                                    {t('Selected File')}: {file.name}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row p-2'>
                    {loading ? <div className="text-center pt-5"><Spinner animation="border" variant="success" /></div> : (props.versions.length > 0) ? <div className="table-responsive scrollSorfVer">
                        <Table hover className='gridsStyle'>
                            <thead>
                                <tr>
                                    <th>{t('Version')}</th>
                                    <th>{t('CRC')}</th>
                                    <th>{t('Date')}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.versions.map((v, i) => {
                                    return (<tr key={i} className={`tableLine`}>
                                        <td>{v.version}</td>
                                        <td>{v.crc}</td>
                                        <td>{v.date}</td>
                                        <td className="text-end col-1"><button onClick={() => null} className='btn-Custom btn-IDRed me-3 buttonRadius'><i className="bi bi-trash"></i></button></td>
                                    </tr>)
                                })}
                            </tbody>
                        </Table>
                    </div> : <p className='text-center p-5'>{t('NoSoftwareVersions')}</p>}
                </div>
            </div>
        </>
    )
}

export default SoftwareVersions